import React from 'react';

/**
 * FeatureLockedOverlay
 *
 * Renders a frosted-glass overlay over its parent container when `locked` is true.
 * The parent MUST have `position: relative` (or absolute/fixed) for the overlay
 * to fill it correctly — all four existing pages already do this.
 *
 * Props:
 *   locked  {boolean}  — show the overlay when true
 *   title   {string}   — headline inside the lock card   (default: "Features Locked")
 *   message {string}   — sub-text inside the lock card   (default: generic connect message)
 */
const FeatureLockedOverlay = ({
                                  locked,
                                  title   = 'Features Locked',
                                  message = 'Connect your Amazon account to unlock this feature.',
                              }) => {
    if (!locked) return null;

    return (
        <div
            style={{
                position:        'absolute',
                top:             0,
                left:            -10,
                right:           -10,
                bottom:          0,
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                backdropFilter:  'blur(5px)',
                zIndex:          10,
                display:         'flex',
                alignItems:      'center',
                justifyContent:  'center',
                borderRadius:    '12px',
            }}
        >
            <div className="text-center bg-white p-8 shadow-sm rounded border">
                <i className="ki-outline ki-lock-2 fs-3x text-muted mb-4" />
                <h3 className="text-gray-800">{title}</h3>
                <p className="text-muted">{message}</p>
            </div>
        </div>
    );
};

export default FeatureLockedOverlay;